import React, { ReactElement, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import "./Reaction.scss";
import Avatar from "../Avatar";
import blankProfile from "./blank-profile.svg";
import { removeReaction } from "../../actions";

interface ReactionProps {
  userName: string;
  reaction: string;
  timestamp: Date;
  profilePictureUrl: string | null;
  description?: string | null;
}

const REACTION_DISPLAY_TIME = 5000;

const getReactionMarkup = (
  userName: string,
  reaction: string,
  description: string
): ReactElement<ReactionProps> => {
  const reactionWithoutDescription = (
    <>
      <div className="top-line">
        <span className="user-name">{userName}</span> reacted
      </div>
      <div className="reaction-emoji">{reaction}</div>
    </>
  );

  const reactionWithDescription = (
    <>
      <div className="top-line">
        <span>{description}</span>
      </div>
    </>
  );

  return description && description.length > 0
    ? reactionWithDescription
    : reactionWithoutDescription;
};

const Reaction = (props: ReactionProps): ReactElement<ReactionProps> => {
  const dispatch = useDispatch();

  const { reaction, timestamp, userName, profilePictureUrl, description } =
    props;
  const [className, setClassName] = useState("");

  useEffect(() => {
    const reactionTimeout = setTimeout(() => {
      setClassName("fade-out");
      clearTimeout(reactionTimeout);
      const cleanReactionTimeout = setTimeout(() => {
        dispatch(
          removeReaction({
            reaction,
            timestamp,
            userName,
            profilePictureUrl: profilePictureUrl || "",
          })
        );

        clearTimeout(cleanReactionTimeout);
      }, 500);
    }, REACTION_DISPLAY_TIME);
    return () => {
      clearTimeout(reactionTimeout);
    };
  }, [dispatch, profilePictureUrl, reaction, timestamp, userName]);

  return (
    <div className={"fade-in"}>
      <div className={className}>
        <div className={"reaction"}>
          <Avatar
            url={profilePictureUrl || blankProfile}
            className="reaction-avatar"
          />
          <div className="content">
            {getReactionMarkup(userName, reaction, description as string)}
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(Reaction);
